import {
  Button,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Divider,
  ListItem,
  ListItemText,
  List,
} from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import { SubTitle, Title, FormField } from 'componentsHsc'
import { FormControl } from '..'
import { RootState } from 'reducers'
import { useSelector, useDispatch } from 'react-redux'
import { getMcaxs491Init } from 'reducers/advancedSearchModalReducer'
import { magiContants as contants } from 'utils/contants'
import {
  WebSeminarObj,
  WebSeminarConditionObj,
  WebSeminarWatchingStatusConditionObj,
} from '../Config/searchConditionConfig'
import { WebSeminarLevel2, WebSeminarLevel3 } from '../Config/seminarMediaModalConfig'

import { getMessage } from 'common/messageUtil'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { Tooltip as MuiTooptip, IconButton } from '@material-ui/core'
import CustomScrollbar from 'react-custom-scrollbars'
import { isEmpty } from 'common/generalUtil'

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'visible !important'
  },
  actions: {
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  dialogTitle: {
    color: (theme.palette as any).white,
    backgroundColor: '#133e80',
    '&:hover': {
      backgroundColor: '#133e80',
    },
  },
  title: {
    color: (theme.palette as any).white,
    fontWeight: 900,
    fontSize: 18,
    cursor:'auto',
  },
  select: {
    // 28P #95801 START
    width: '40%',
    // 28P #95801 END
    display: 'flex',
    '& > :first-child': {
      flex: 2,
    },
    '& > :last-child': {
      flex: 3,
    },
    '& span': {
      color: colors.grey[600],
    },
  },
  content: {
    height: 'inherit !important',
  },
  cancel: {
    color: '#1a1a1a',
    border: '1px solid',
    borderRadius: '4px',
    backgroundColor: '#e0e0e0',
    borderColor: '#cbcbcb',
    '&:hover': {
      backgroundColor: '#c1d1eb',
      borderColor: '#999999',
    },
    minWidth: 150,
    marginRight: '20px'
  },
  confirmButton: {
    color: '#ffffff',
    border: '1px solid',
    borderRadius: '4px',
    backgroundColor: '#3380cc',
    borderColor: '#3380cc',
    '&:hover': {
      backgroundColor: '#4596e6',
      borderColor: '#3380cc',
    },
    minWidth: 150,
    marginLeft: '20px !important'
  },
  dividerColor: {
    backgroundColor: colors.grey[600],
  },
  labelTitle: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: theme.spacing(3),
  },
  subTitle: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelExplain: {
    lineHeight: '1.5',
    whiteSpace: 'nowrap',
    color: 'black',
  },
  labelTitle2: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: theme.spacing(3),
    marginLeft:theme.spacing(15),
  },
  checkBoxItemData: {
    flex: '1 !important',
  },
  checkBoxRoot: {
    marginLeft: '2px',
    '&:hover': {
      backgroundColor: 'transparent!important',
    },
  },
  noCheck: {
    background: 'url(../../css/img/common/checkbox.png) no-repeat 16px 16px #fff',
    border: '1px solid #8592a6',
    borderRadius: '2px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'inline-block',
    height: '16px',
    width: '16px',
    verticalAlign: 'middle',
    '&:hover': {
      borderColor: '#c1d1eb',
    },
  },
  checked: {
    backgroundColor: '#3f71bd',
    backgroundPosition: 'center center',
    borderColor: '#3f71bd',
    background: 'url(../../css/img/common/checkbox.png) no-repeat 16px 16px #fff',
    border: '1px solid #8592a6',
    borderRadius: '2px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'inline-block',
    height: '16px',
    width: '16px',
    verticalAlign: 'middle',
    '&:hover': {
      borderColor: '#c1d1eb',
    },
  },
  rootTooltip: {
    // 28P #95801 START
    marginRight: '22%',
    marginBottom: '0',
    // 28P #95801 END
    display: 'flex',
    alignItems: ({ fullHeight }: any) => 
      fullHeight ? 'stretch' : 'flex-start',
    '& > :first-child': {
      flex: 3,
    },
    '& > :nth-child(2)': {
      flex: 6,
    },
    '& > :last-child': {
      flex: 1,
    },
  },
  buttonTooltip: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  // 28P #95801 START
  divider: {
    margin: theme.spacing(1, 0),
    backgroundColor: 'lightgrey',
  },
  divider2: {
    marginTop: '-10px',
    backgroundColor: 'lightgrey',
  },
  subContent: {
    marginTop: '0px',
    margin: theme.spacing(2),
    '& .Mui-selected': {
        backgroundColor: 'transparent !important',
        color: '#1950a6',
        textDecoration: 'underline',
        '& span': {
            color: '#1950a6',
        },
    },
    height: '100%',
  },
  seminarTitleList: {
    wordBreak:'break-all',
    wordWrap:'break-word',
    '& > div:first-child': {
        marginBottom: '0px !important',
        overflowX: 'hidden !important',
        maxHeight: '500px !important',
    }
  },
  seminarTitleList2 : {
    '& > ul' : {
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
    },
    '& > ul > div' : {
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
    },
    '& > ul > div > div' : {
        marginTop: '2px !important',
        marginBottom: '2px !important',
    },
    '& > ul > div > div > span' : {
        color: '#263238'
    }
  },
  seminarDetail: {
      wordBreak:'break-all',
      wordWrap:'break-word',
      '& > div:first-child': {
          marginBottom: '0px !important',
          overflowX: 'hidden !important',
          maxHeight: '500px !important',
      }
  },
  seminarDetail2: {
      '& > div > :first-child':{
          overflowX: 'hidden !important',
      }
  },
  body: {
      display: 'flex',
      justifyContent: 'space-between',
  },
  webSeminarTitleAndDetail: {
    '& > div': {
      width: '100%',
      margin: '16px 0px'
    },
    '& > div > div > div': {
      width: '210%'
    },
    '& > div > :last-child':{
      flex:0
    }
  },
  webSeminarTitle: {
    display: 'flex',
    flexDirection: 'column',
  },
  displayTitle: {
    '& > div > div > div > p': {
      whiteSpace: 'pre-line'
    }
  }
  // 28P #95801 END
}))

const Tooltip = withStyles({
  tooltip: {
    fontSize: '1em',
    maxWidth: '500px',
  },
  popper: {
    whiteSpace: 'pre-line'
  }
})(MuiTooptip)

const searchOptionList = [
  { label: 'AND', value: '0' },
  { label: 'OR', value: '1' },
]

const optionList = [
  { label: '未視聴', value: '0' },
  { label: '視聴中', value: '1' },
  { label: '視聴済', value: '2' },
]

interface Props {
  open: boolean
  onClose: () => void
  form: FormControl
}

// 28P #95801 START
interface RdoSeletData {
  [key: number]: boolean[]
  dateId: number
  rdoVal: boolean[]
}
// 28P #95801 END

const SeminarMediaModal = ({ open, onClose, form }: Props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [confirm, setConfirm] = useState(false)
  const [selectedSearchType, setSelectedSearchType] = useState([] as boolean[])
  // 28P #95801 START
  const [checkBoxItemData, setCheckBoxItemData] = useState<RdoSeletData[]>([])
  // 28P #95801 END
  const [selectAllFlag, setSelectAllFlag] = useState([false,false,false] as boolean[])
  // 28P #95801 START
  const [selectedSub, setSelectedSub] = useState('') // 説明会・面接名リストクリック時に画面のスクロール
  // 28P #95801 END

  const icon = () => {return <div className={classes.noCheck} />}
  const iconChecked = () => {return <div className={classes.checked} />}

  const { webSeminarList } = useSelector(
    (state: RootState) => state.advancedSearchModal.seminarMediaModalInfo
  )

  useEffect(() => {
    dispatch(getMcaxs491Init())
  }, [open])

  useEffect(() => {
    if (open) {
      // 28P #95801 START
      setSelectedSub('')
      // 28P #95801 END
      if (form.values.webSeminarObj) {
        let flglst: boolean[] = []
        if (form.values.webSeminarObj.webSeminarConditionJudgmentFlag === 0) {
          flglst.push(true)
          flglst.push(false)
        } else {
          flglst.push(false)
          flglst.push(true)
        }
        setSelectedSearchType(flglst)
        if (form.values.webSeminarObj.webSeminarConditionObj) {
          // 28P #95801 START
          let checkBoxItemDataList: RdoSeletData[] = []
          // 28P #95801 END
          const fromval = form.values.webSeminarObj.webSeminarConditionObj

          // 28P #95801 START
          if (webSeminarList) {
            webSeminarList.map((item1, index1) => {
              item1.webSeminarLevel2Dto.map((item2, index2) => {
                item2.webSeminarLevel3Dto.map((item3, index3) => {
                  let checkBoxItem : boolean[] = [false, false, false]
                  for(var z = 0; z < fromval.length; z++) {
                    if (
                      fromval[z].webSeminarSeminarScheduleId ===
                        item3.seminarScheduleId &&
                      fromval[z].webSeminarCoordinationFormerWebSeminarId ===
                        item3.coordinationFormerWebSeminarId &&
                      fromval[z].webSeminarTitle ===
                        item3.webSeminarTitle
                    ) {
                      if (fromval[z].webSeminarWatchingStatusConditionObj !== null ) {
                        for (let k = 0; k < fromval[z].webSeminarWatchingStatusConditionObj.length; k++) {
                          if(0 == fromval[z].webSeminarWatchingStatusConditionObj[k].webSeminarWatchingStatusConditionFlag) {
                            checkBoxItem[0] = true
                          } else if(1 == fromval[z].webSeminarWatchingStatusConditionObj[k].webSeminarWatchingStatusConditionFlag) {
                            checkBoxItem[1] = true
                          } else if(2 == fromval[z].webSeminarWatchingStatusConditionObj[k].webSeminarWatchingStatusConditionFlag) {
                            checkBoxItem[2] = true
                          }
                        }
                        break
                      }
                    }
                  }
                  checkBoxItemDataList.push({
                    dateId: Number(item3.seminarScheduleId),
                    rdoVal: checkBoxItem
                  })
                })
              })
            })
          }
          // 28P #95801 END
          setCheckBoxItemData(checkBoxItemDataList)
          let selectAllFlag2: boolean[] = []
          for (let g = 0; g < 3; g++) {
            // 28P #95801 START
            let selectAllFlagChecksTrue = checkBoxItemDataList.filter(i => i.rdoVal[g] === true)
            // 28P #95801 END
            if (checkBoxItemDataList.length != 0 && selectAllFlagChecksTrue.length === checkBoxItemDataList.length) {
              selectAllFlag2[g] = true
            } else {
              selectAllFlag2[g] = false
            }
          }
          setSelectAllFlag(selectAllFlag2)
        }
      } else {
        let flglst: boolean[] = []
        // 28P #95801 START
        let checkBoxItemDataList: RdoSeletData[] = []
        // 28P #95801 END
        flglst.push(true)
        flglst.push(false)
        setSelectedSearchType(flglst)
        setSelectAllFlag([false,false,false])

        // 28P #95801 START
        if (webSeminarList) {
          webSeminarList.map((item1, index1) => {
            item1.webSeminarLevel2Dto.map((item2, index2) => {
              item2.webSeminarLevel3Dto.map((item3, index3) => {
                checkBoxItemDataList.push({
                  dateId: Number(item3.seminarScheduleId),
                  rdoVal: [false,false,false]
                })
              })
            })
          })
        }
        // 28P #95801 END
        setCheckBoxItemData(checkBoxItemDataList)
      }
    }
  }, [open])

  const handleClick = (open = true) => () => {
    setConfirm(open)
  }

  const handleClose = () => {
    setConfirm(false)
    onClose()
  }

  const handleSubmit = () => {
    let webSeminarObj: WebSeminarObj = {
      webSeminarConditionJudgmentFlag: 1,
      webSeminarConditionJudgmentName: '',
      webSeminarConditionObj: [],
    }

    var searchValue: any = document.getElementsByName('seminarMediaSearch')
    if (searchValue) {
      if (searchValue[0].checked) {
        webSeminarObj.webSeminarConditionJudgmentFlag = 0
        webSeminarObj.webSeminarConditionJudgmentName = 'AND'
      } else if (searchValue[1].checked) {
        webSeminarObj.webSeminarConditionJudgmentFlag = 1
        webSeminarObj.webSeminarConditionJudgmentName = 'OR'
      }

      // 28P #95801 START
      webSeminarList.map((item1, index1) => {
        item1.webSeminarLevel2Dto.map((item2, index2) => {
          item2.webSeminarLevel3Dto.map((item3, index3) => {
            var searchValue3: any = document.getElementsByName(
              `selectSearch3[${index1}_${index2}_${index3}]`
            )
            if (searchValue3) {
              let webSeminarConditionObj: WebSeminarConditionObj = {
                webSeminarApplicationRouteId: item3.contractMediaId,
                webSeminarApplicationRouteName: item3.contractMediaName,
                webSeminarSeminarScheduleId:
                  item3.seminarScheduleId,
                webSeminarCoordinationFormerWebSeminarId:
                  item3.coordinationFormerWebSeminarId,
                webSeminarTitle: item3.webSeminarTitle,
                webSeminarEventDate: item3.eventDate,
                webSeminarEventDateText: item3.eventDateText,
                webSeminarStartTime: item3.startTime,
                webSeminarEndTime: item3.endTime,
                webSeminarSeminarScheduleTitle: item3.seminarScheduleTitle,
                webSeminarWatchingStatusConditionFlag: 0,
                webSeminarWatchingStatusConditionName: '',
                webSeminarWatchingStatusConditionObj: []
              }
              let objFlg = false

              if (searchValue3[0].checked) {
                let webSeminarWatchingStatusConditionObj: WebSeminarWatchingStatusConditionObj = {
                  webSeminarWatchingStatusConditionFlag: 0,
                  webSeminarWatchingStatusConditionName: ''
                }
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionFlag = 0
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionName = '未視聴'
                webSeminarConditionObj.webSeminarWatchingStatusConditionObj.push(webSeminarWatchingStatusConditionObj)
                objFlg = true
              }
              if (searchValue3[1].checked) {
                let webSeminarWatchingStatusConditionObj: WebSeminarWatchingStatusConditionObj = {
                  webSeminarWatchingStatusConditionFlag: 1,
                  webSeminarWatchingStatusConditionName: ''
                }
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionFlag = 1
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionName = '視聴中'
                webSeminarConditionObj.webSeminarWatchingStatusConditionObj.push(webSeminarWatchingStatusConditionObj)
                objFlg = true
              }
              if (searchValue3[2].checked) {
                let webSeminarWatchingStatusConditionObj: WebSeminarWatchingStatusConditionObj = {
                  webSeminarWatchingStatusConditionFlag: 2,
                  webSeminarWatchingStatusConditionName: ''
                }  
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionFlag = 2
                webSeminarWatchingStatusConditionObj.webSeminarWatchingStatusConditionName = '視聴済'
                webSeminarConditionObj.webSeminarWatchingStatusConditionObj.push(webSeminarWatchingStatusConditionObj)
                objFlg = true
              }
              if (objFlg) {
                webSeminarObj.webSeminarConditionObj.push(webSeminarConditionObj)
              }
            }
          })
        })
      })
      // 28P #95801 END
    }

    if (webSeminarObj.webSeminarConditionObj.length > 0) {
      form.setFieldValue('webSeminarObj', webSeminarObj)
    } else {
      form.setFieldValue('webSeminarObj', null)
    }

    handleClose()
    // TODO: formik
  }

  const handleChangeSearchType = (e: any) => {
    let flglst: boolean[] = []
    if (e.target.value === '0') {
      flglst.push(true)
      flglst.push(false)
    } else {
      flglst.push(false)
      flglst.push(true)
    }
    setSelectedSearchType(flglst)
  }

  const handleCheckBoxAllChange = (e: any) => {
    let selectAllFlag2: boolean[] = []
    selectAllFlag2.push(selectAllFlag[0])
    selectAllFlag2.push(selectAllFlag[1])
    selectAllFlag2.push(selectAllFlag[2])
    selectAllFlag2[e.target.value] = e.target.checked
    setSelectAllFlag(selectAllFlag2)

    // 28P #95801 START
    let checkBoxItemData2: RdoSeletData[] = []
    // 28P #95801 END
    for (let i = 0; i < checkBoxItemData.length; i++) {
      checkBoxItemData2.push(checkBoxItemData[i])
      // 28P #95801 START
      checkBoxItemData2[i].rdoVal[e.target.value] = e.target.checked
      // 28P #95801 END
    }
    setCheckBoxItemData(checkBoxItemData2)
  }

  const handleCheckBoxItemDataSelect = (index: number) => (e: any) => {
    if (checkBoxItemData && checkBoxItemData.length > 0) {
      // 28P #95801 START
      let checkBoxItemData2: RdoSeletData[] = []
      // 28P #95801 END
      for (let i = 0; i < checkBoxItemData.length; i++) {
        checkBoxItemData2.push(checkBoxItemData[i])
        // 28P #95801 START
        if (checkBoxItemData[i].dateId == index) {
          checkBoxItemData2[i].rdoVal[e.target.value] = e.target.checked
        }
        // 28P #95801 END
      }
      setCheckBoxItemData(checkBoxItemData2)

      // 28P #95801 START
      let selectAllFlagChecksTrue = checkBoxItemData.filter(i => i.rdoVal[e.target.value] === true)
      // 28P #95801 END
      let selectAllFlag2: boolean[] = []
      selectAllFlag2.push(selectAllFlag[0])
      selectAllFlag2.push(selectAllFlag[1])
      selectAllFlag2.push(selectAllFlag[2])

      if (selectAllFlagChecksTrue.length === checkBoxItemData.length) {
        selectAllFlag2[e.target.value] = true
      } else {
        selectAllFlag2[e.target.value] = false
      }
      setSelectAllFlag(selectAllFlag2)
    }
  }

  // 28P #95801 START
  // 説明会タイトル(左側)を押下する
  const handleSubClick = (index1: number, index2: number) => () => {
    setSelectedSub(index1 + '_' + index2)
    const toTop = document.getElementById(`sel_${index1}_${index2}`)
    if (toTop) {
        toTop.scrollIntoView()
    }
  }

  // 説明会タイトルに表示する情報を再作成する
  const createWebSeminarTitle = (webSeminar : WebSeminarLevel2) => {
    let result = ''
    if (!isEmpty(webSeminar.coordinationFormerSeminarId)) {
      result = webSeminar.coordinationFormerSeminarId
      if (!isEmpty(webSeminar.seminarName)) {
        result += ' ' + webSeminar.seminarName
      }
    } else if (!isEmpty(webSeminar.seminarName)) {
      result = webSeminar.seminarName
    }
    if (contants.STRING_0 === webSeminar.publicFlag) {
      result +='【非公開】'
    }
    return result
  }

  // WEBセミナー詳細名に表示する情報を再作成する
  const createWebSeminarName = (webSeminar : WebSeminarLevel3) => {
    const eventDate = webSeminar.eventDate
    const startTime = webSeminar.startTime
    const endTime = webSeminar.endTime
    const eventDateText = webSeminar.eventDateText
    const seminarScheduleTitle = webSeminar.seminarScheduleTitle
    const webSeminarTitle = webSeminar.webSeminarTitle
    const invisibleFlag = webSeminar.invisibleFlag
    let eventDateTime = ''
    let result = ''
    
    if (null == eventDate) {
      if (isEmpty(eventDateText)) {
        result = isEmpty(seminarScheduleTitle) ? '' : seminarScheduleTitle
      } else {
        result = eventDateText + ' ' + (isEmpty(seminarScheduleTitle) ? '' : seminarScheduleTitle)
      }
      if (contants.STRING_1 === invisibleFlag) {
        result += '【非表示】' + '\r\n' + webSeminarTitle
      } else {
        result += isEmpty(eventDateText) && isEmpty(seminarScheduleTitle) ? (webSeminarTitle) : ('\r\n' + webSeminarTitle)
      }
    } else {
      if (!isEmpty(startTime) && !isEmpty(endTime)) {
        eventDateTime = eventDate + ' ' + startTime + '～' + endTime
      } else if (isEmpty(startTime) && !isEmpty(endTime)) {
        eventDateTime = eventDate + ' ' + '～' + endTime
      } else if (!isEmpty(startTime) && isEmpty(endTime)) {
        eventDateTime = eventDate + ' ' + startTime + '～'
      } else if (isEmpty(startTime) && isEmpty(endTime)) {
        eventDateTime = eventDate
      }

      result = eventDateTime + ' ' + (isEmpty(seminarScheduleTitle) ? '' : seminarScheduleTitle)
      if (contants.STRING_1 === invisibleFlag) {
        result += '【非表示】' + '\r\n' + webSeminarTitle
      } else {
        result += '\r\n' + webSeminarTitle
      }
    }

    return result
  }

  // WEBセミナー詳細各チェックボックス状態
  const rdoChecked = (id: number, option: any) => {
    let rdoSelectData = checkBoxItemData.find(item => {
      return item.dateId == id
    })
    if (rdoSelectData) {
      return rdoSelectData.rdoVal[Number(option.value)]
    }
    return false
  }
  // 28P #95801 END

  return (
    <div>
      {/* 28P #95801 START */}
      <Dialog fullWidth open={open} maxWidth='lg' className={'mainDialog'}>
      {/* 28P #95801 END */}
        <DialogTitle className={classes.dialogTitle}>
          {/* 28P #95801 START */}
          <label className={classes.title}>オフィシャル配信視聴状況を指定</label>
          {/* 28P #95801 END */}
        </DialogTitle>
        <DialogContent>
          <div className={`ps-container ps ${classes.root}`}>
            <div className={classes.subTitle}>
            <RadioGroup row onChange={handleChangeSearchType}>
                <FormLabel className={classes.labelTitle}>
                  {/* 28P #95801 START */}
                  オフィシャル配信間の検索方法
                  {/* 28P #95801 END */}
                </FormLabel>
              {searchOptionList
                ? searchOptionList.map((item, index1) => (
                    <>
                      <FormControlLabel
                        control={
                          <Radio
                            color='primary'
                            name='seminarMediaSearch'
                            checked={
                              selectedSearchType
                                ? selectedSearchType[index1]
                                : undefined
                            }
                            value={item.value}
                          />
                        }
                        label={item.label}
                      />
                    </>
                  ))
                : null}
            </RadioGroup>
            <div>
                <FormLabel className={classes.labelTitle2}>
                  一括チェック　　
                </FormLabel>
                <FormControlLabel
                  control={
                    <Checkbox color='primary' value='0' name='selectSearch4' checked={selectAllFlag[0] === true}
                              onChange={handleCheckBoxAllChange}
                              className={classes.checkBoxRoot}
                              icon={icon()}
                              checkedIcon={iconChecked()}
                    />
                  }
                  label='未視聴'
                />
                <FormControlLabel
                  control={
                    <Checkbox color='primary' value='1' name='selectSearch4' checked={selectAllFlag[1] === true}
                              onChange={handleCheckBoxAllChange}
                              className={classes.checkBoxRoot}
                              icon={icon()}
                              checkedIcon={iconChecked()}
                    />
                  }
                  label='視聴中'
                />
                <FormControlLabel
                  control={
                    <Checkbox color='primary' value='2' name='selectSearch4' checked={selectAllFlag[2] === true}
                              onChange={handleCheckBoxAllChange}
                              className={classes.checkBoxRoot}
                              icon={icon()}
                              checkedIcon={iconChecked()}
                    />
                  }
                  label='視聴済'
                />
                </div>
            </div>
          <div className={classes.subTitle}>
            <FormLabel className={classes.labelExplain}>
              {/* 28P #208839 START */}
              {/* 28P #95801 START */}
              1つのオフィシャル配信に対して、複数の視聴状況を選択して検索できます。
              {/* 28P #95801 END */}
              <br />
              その場合の検索結果は「OR検索」になります。
              {/* 28P #208839 END */}
            </FormLabel>
            {/* 28P #95801 START */}
            <div className={`${classes.rootTooltip}`}>
              <Tooltip title={getMessage('MCAXS491-002')} placement='bottom' tabIndex={-1}>
                <IconButton className={classes.buttonTooltip}>
                  <HelpOutlineIcon fontSize='large' />
                </IconButton>
              </Tooltip>
            {/* 28P #95801 END */}
            </div>
            </div>
          {/* 28P #95801 START   */}
          <Divider className={classes.divider} />
          <div className={classes.body}>
            <div className={classes.select}>
              <div className={classes.subContent}>
                <CustomScrollbar autoHeight={true} autoHeightMin={0} autoHeightMax={500} className={classes.seminarTitleList}>
                  {webSeminarList
                    ? webSeminarList.map((webSeminar1, index1) => (
                      <div className={classes.seminarTitleList2}>
                        <div>{webSeminar1.contractMediaName}</div>
                        {webSeminar1.webSeminarLevel2Dto.map((webSeminar2, index2) => (
                          <>
                            <List>
                              <ListItem
                                button
                                tabIndex={-1}
                                selected={selectedSub === `${index1}_${index2}`}
                                onClick={handleSubClick(index1, index2)}>
                                  <ListItemText
                                    primary={createWebSeminarTitle(webSeminar2)}
                                  />
                                </ListItem>
                            </List>
                          </>
                        ))}
                      </div>
                    )) : null}
                </CustomScrollbar>
              </div>
            </div>
            <div style={{width: '100%', height: '100%' }} className={`${classes.seminarDetail} ${classes.seminarDetail2}`}>
              <CustomScrollbar autoHeight={true} autoHeightMax={500}>
                {webSeminarList
                  ? webSeminarList.map((webSeminar1, index1) => (
                      <>
                        {/* 28P #11776 START */}
                        <SubTitle variant='h4'>
                        {/* 28P #11776 END */}
                          {webSeminar1.contractMediaName}
                        </SubTitle>
                        {webSeminar1.webSeminarLevel2Dto.map((webSeminar2, index2) => (
                          <>
                            <div id={`sel_${index1}_${index2}`} className={classes.webSeminarTitleAndDetail}>
                              <div className={classes.webSeminarTitle}>
                                <SubTitle variant='h5' noUnderline>
                                  {createWebSeminarTitle(webSeminar2)}
                                </SubTitle>
                              </div>
                              <Divider className={classes.divider2} />
                              {webSeminar2.webSeminarLevel3Dto.map((webSeminar3, index3) => (
                                <>
                                  <FormField className={classes.displayTitle}>
                                    <Title
                                      title={createWebSeminarName(webSeminar3)}
                                    />
                                    <div style={{marginLeft: '32%'}}>
                                      {optionList
                                        ? optionList.map((item1, index) => (
                                            <>
                                              <FormControlLabel className={classes.checkBoxItemData}
                                                control={
                                                  <Checkbox color='primary' 
                                                            name={`selectSearch3[${index1}_${index2}_${index3}]`}
                                                            checked={rdoChecked(Number(webSeminar3.seminarScheduleId), item1)}
                                                            value={item1.value}
                                                            onChange={handleCheckBoxItemDataSelect(Number(webSeminar3.seminarScheduleId))}
                                                            className={classes.checkBoxRoot}
                                                            icon={icon()}
                                                            checkedIcon={iconChecked()}
                                                  />
                                                }
                                                label={item1.label}
                                              />
                                            </>
                                          ))
                                        : null}
                                    </div>
                                  </FormField>
                                </>
                              ))}
                            </div>
                          </>
                        ))}
                      </>
                    ))
                  : null}
              </CustomScrollbar>
            </div>
          </div>
          {/* 28P #95801 END */}
          </div>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
            onClick={handleClick()}
            color='primary'
            variant='contained'
            className={classes.cancel}>
            キャンセルする
          </Button>
          <Button
            onClick={handleSubmit}
            color='primary'
            variant='contained'
            className={classes.confirmButton}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirm} onClose={handleClick(false)}>
        <DialogTitle>{contants.MESSAGECODE_MCAXS491_001}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClick(false)}>キャンセル</Button>
          <Button onClick={handleClose} color='primary'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default SeminarMediaModal
